var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"justify-space-around":"","wrap":""}},[_c('bol-large-button',{attrs:{"icon":"book","label":this.$t('navigation.administration.book'),"route":"/administration/book"}}),_c('bol-large-button',{attrs:{"icon":"bookmarks","label":this.$t('navigation.administration.magazine'),"route":"/administration/magazine"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }